<template>
  <div class="partyActivityAdd">
    <el-card>
      <div class="jump-btn">
        <el-button type="primary" @click="back">返回</el-button>
      </div>
      <el-form :model="ruleForm" name="frm" :rules="rules" ref="ruleForm" class="wid100"
        :label-width="require('@/config/enum').c_ws12" :label-suffix="require('@/config/enum').c_colon">
        <el-form-item tem label="项目名称" prop="gardenId">
          <el-select v-model="ruleForm.gardenId" placeholder="请选择项目">
            <el-option v-for="item in gardens" :key="item.id" :value="item.id" :label="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item tem label="活动标题" prop="activityName">
          <el-input v-model="ruleForm.activityName" placeholder="请输入活动标题" class="item-input" maxlength="50"></el-input>
        </el-form-item>
        <!-- 内容 -->
        <el-form-item label="活动内容" prop="activityContent" class="editor-width">
          <quill-editor v-model="ruleForm.activityContent" ref="myQuillEditor" :options="editorOption"
            @change="onEditorChange($event)"></quill-editor>
          <span class="editorText"
            v-show="isLength < 10001">{{$t('lang.lab_editor_tip1')}}{{isLength}}{{$t('lang.lab_editor_tip2')}}{{10000-isLength}}{{$t('lang.lab_editor_tip3')}}</span>
          <span class="editorTextTips" v-show="isLength >= 10001">{{$t('lang.lab_editor_tips')}}</span>
        </el-form-item>
        <!-- 按钮 -->
        <el-button class="btn-first" @click="resetForm('ruleForm')">{{$t('lang.btn_rest')}}</el-button>
        <el-button class="detailbtn" type="primary" @click="save('ruleForm')" :disabled="isDisabled">
          {{$t('lang.btn_save')}}
        </el-button>
      </el-form>
    </el-card>
  </div>
</template>

<script>
  /**
   *@ClassName:partyActivityAdd
   *@Description:党建活动新增、修改
   *@author:杜斌
   *@Copyright:格众科技
   *@date:2020-02-19
   */
  // 引入富文本title汉字
  import {
    addQuillTitle
  } from '../../../config/quill-title.js'
  import {
    mapGetters
  } from 'vuex'
  export default {
    data() {
      return {
        arr: [],
        id: '', // id
        gardens: '', // 小区名称
        isLength: 0, // 富文本字数长度
        isDisabled: true, // 保存的可点击
        saveData: '',
        rules: {
          gardenId: [{
            required: true,
            message: '请选择项目',
            trigger: 'change'
          }],
          activityName: [{
            required: true,
            message: '请输入活动标题',
            trigger: 'blur'
          }],
          activityContent: [{
            required: true,
            message: '请输入活动内容',
            trigger: 'blur'
          }],
        },
        ruleForm: {
          gardenId: '', // 项目id
          activityName: '', // 活动标题
          activityContent: '', // 活动内容
        },
        editorOption: {
          modules: {
            toolbar: [
              ['bold', 'italic', 'underline', 'strike'], // 加粗，斜体，下划线，删除线
              ['blockquote', 'code-block'], // 引用，代码块
              [{
                header: 1
              }, {
                header: 2
              }], // 标题，键值对的形式；1、2表示字体大小
              [{
                list: 'ordered'
              }, {
                list: 'bullet'
              }], // 列表
              [{
                script: 'sub'
              }, {
                script: 'super'
              }], // 上下标
              [{
                indent: '-1'
              }, {
                indent: '+1'
              }], // 缩进
              [{
                direction: 'rtl'
              }], // 文本方向
              [{
                size: ['small', false, 'large', 'huge']
              }], // 字体大小
              [{
                header: [1, 2, 3, 4, 5, 6, false]
              }], // 几级标题
              [{
                color: []
              }, {
                background: []
              }], // 字体颜色，字体背景颜色
              [{
                font: []
              }], // 字体
              [{
                align: []
              }], // 对齐方式
              ['clean'], // 清除字体样式
              ['image', 'video'] // 上传图片、上传视频
            ]
          },
          theme: 'snow',
          placeholder: this.$i18n.t('lang.lab_text'),
        }
      }
    },
    watch: {
      ruleForm: {
        handler(newVal, oldVal) {
          // ruleForm数据变化时 会调用此方法
          let tempRule = JSON.stringify(newVal)
          if (tempRule === this.saveData) {
            // 没变
            this.isDisabled = true
          } else {
            // 变了
            this.isDisabled = false
          }
        },
        deep: true,
        immediate: true
      },
      'ruleForm.gardenId': function (a, b) {
        let that = this
        for (var key in that.arr) {
          if (that.arr[key].id === a && (!that.arr[key].longitude && !that.arr[key].latitude)) {
            this.$message.info('请录入：' + that.arr[key].name + ' 的经纬度')
          }
        }
      },
    },
    computed: {
      ...mapGetters(['gardenId']),
      editor() {
        return this.$refs.myQuillEditor.quill
      }
    },
    created() {
      this.selectGarden()
      this.getData()
    },
    methods: {
      // 返回上一级
      back() {
        this.$router.push({
          name: 'partyActivityList'
        })
      },
      // 获取小区列表
      selectGarden() {
        this.$get(`/gardens`).then(
          res => {
            if (res && res.errCode === 0) {
              console.log(res)
              this.gardens = res.list
              let arr = []
              for (let index = 0; index < res.list.length; index++) {
                let obj = {}
                obj.id = res.list[index].id
                obj.name = res.list[index].name
                obj.longitude = res.list[index].longitude
                obj.latitude = res.list[index].latitude
                arr.push(obj)
              }
              console.log(arr)
              this.arr = arr
            }
          },
          error => {
            this.$message.error(error)
          }
        )
      },
      // 获取详情数据
      getData() {
        var rowData = this.$route.query.rowData
        console.log(rowData)
        if (rowData) {
          this.ruleForm.gardenId = rowData.gardenId
          this.ruleForm.activityName = rowData.activityName
          this.ruleForm.activityContent = rowData.activityContent
          this.id = rowData.id
          this.saveData = JSON.stringify(this.ruleForm)
        }
      },
      // 保存
      save(formName) {
        let params = this.ruleForm
        console.log('params', params)
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let loading = this.$loading()
            if (!this.id) {
              // 新增
              this.$post('/partyActivity', params).then(
                res => {
                  loading.close()
                  console.log(res)
                  if (res && res.errCode === 0) {
                    this.$message.success(this.$i18n.t('lang.lab_save_success'))
                    this.back()
                  }
                },
                error => {
                  loading.close()
                  this.$message.error(error)
                }
              )
            } else {
              // 编辑
              this.$patch(`/partyActivity/${this.id}`, params).then(
                res => {
                  loading.close()
                  console.log(res)
                  if (res && res.errCode === 0) {
                    this.$message.success(this.$i18n.t('lang.lab_save_success'))
                    this.back()
                  }
                },
                error => {
                  loading.close()
                  this.$message.error(error)
                }
              )
            }
          } else {
            return false
          }
        })
      },
      // 清空
      resetForm(formName) {
        this.ruleForm.gardenId = ''
        this.ruleForm.activityName = ''
        this.ruleForm.activityContent = ''
      },
      // 内容字数提示
      onEditorChange(event) {
        event.quill.deleteText(10000, 4)
        if (this.ruleForm.content === '') {
          this.isLength = 0
        } else {
          this.isLength = event.quill.getLength() - 1
        }
      },

    },
    // 富文本字数限制显示位置
    mounted() {
      addQuillTitle()
    }
  }
</script>

<style lang="scss">
  .partyActivityAdd {

    .item-input,
    .el-select,
    .el-date-editor.el-input {
      width: 30%;
    }

    .editor-width {
      width: 80%;
    }

    .item-select {
      display: inline-block
    }

    .empty-input {
      display: none
    }
  }
</style>